import { render, staticRenderFns } from "./Navigation_UserContent.vue?vue&type=template&id=b8fc7268&"
import script from "./Navigation_UserContent.vue?vue&type=script&lang=js&"
export * from "./Navigation_UserContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports